import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20illustration%20of%20a%20cozy%20reading%20corner%20with%20an%20open%20comic%20book%20on%20a%20wooden%20desk%2C%20soft%20warm%20lighting%20from%20a%20lamp%2C%20bookshelves%20in%20the%20background%2C%20Korean%20manhwa%20style%20art%20elements%20floating%20around%2C%20warm%20amber%20and%20cream%20tones%2C%20artistic%20abstract%20composition%2C%20cozy%20atmosphere&width=1920&height=900&seq=hero-bg-home-01&orientation=landscape"
        alt="非麻瓜漫画 - 免费韩漫在线阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-10">
          <div className="lg:w-3/5 text-center lg:text-left">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight">
              免费
              <span className="block mt-1">韩漫</span>
              <span className="block mt-1 text-primary-400">在线阅读</span>
            </h1>
            <p className="mt-5 text-base md:text-lg text-background-200/90 max-w-lg mx-auto lg:mx-0 leading-relaxed">
              海量韩国漫画免费看，支持下拉式阅读体验。每日更新最新韩漫全集，无需注册，打开即看，享受沉浸式漫画阅读之旅。
            </p>
            <div className="mt-7 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <Link
                to="/category/all"
                className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-book-read-line text-lg"></i>
                </span>
                立即探索
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line"></i>
                </span>
              </Link>
              <Link
                to="/about"
                className="px-8 py-3.5 border-2 border-background-50/40 text-background-50 rounded-full text-base font-medium hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>
            <div className="mt-8 flex items-center gap-6 justify-center lg:justify-start text-background-200/70 text-sm">
              <span className="flex items-center gap-1">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-checkbox-circle-fill text-accent-400"></i></span>
                30,000+ 漫画
              </span>
              <span className="flex items-center gap-1">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-checkbox-circle-fill text-accent-400"></i></span>
                每日更新
              </span>
              <span className="flex items-center gap-1">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-checkbox-circle-fill text-accent-400"></i></span>
                完全免费
              </span>
            </div>
          </div>
          <div className="lg:w-2/5 hidden lg:flex justify-center">
            <div className="relative w-64 h-80 rounded-lg overflow-hidden shadow-2xl transform rotate-2">
              <img
                src="https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20woman%20with%20flowing%20hair%20reading%20a%20book%20by%20a%20window%2C%20warm%20sunlight%20streaming%20in%2C%20romantic%20and%20dreamy%20atmosphere%2C%20soft%20pastel%20colors%2C%20delicate%20linework%2C%20cozy%20vibe&width=600&height=800&seq=hero-float-comic-01&orientation=portrait"
                alt="沉浸式韩漫阅读体验"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <span className="w-8 h-8 flex items-center justify-center text-background-50/60">
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </span>
      </div>
    </section>
  );
}